
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"JobAlertDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"JobAlert"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"department"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"icon"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"latlon"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"adminDivisionName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"admin2DivisionName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"countryCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"countryName"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"customFields"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":226}};
    doc.loc.source = {"body":"fragment JobAlertDetails on JobAlert {\n  id\n  department {\n    id\n    name\n    icon\n  }\n  location {\n    id\n    name\n    latlon\n    adminDivisionName\n    admin2DivisionName\n    countryCode\n    countryName\n  }\n  customFields\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    



//////////////////
// WEBPACK FOOTER
// ./src/graphql/fragments/JobAlertDetails.gql
// module id = AQ7/
// module chunks = 39 70